module.exports = __webpack_public_path__ + "static/media/logo.ee1f3f4b.png";